"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { Col, Form, Input, Row, Select, Tooltip } from "antd";

const CustomerEligibilityForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    kycLevelOptions,
    customerSegmentOptions,
    transactionRestriction,
  } = props;

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
        Customer Eligibility
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  KYC Level
                  <Tooltip title="Select the KYC Level">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="kycLevel"
              rules={[
                {
                  required: true,
                  message: "Please select KYC Level",
                },
              ]}
            >
              <Select
                placeholder="Select KYC Level"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={kycLevelOptions}
                // mode="multiple"
                allowClear
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Transaction Restriction
                  <Tooltip title="Select a transaction restriction">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="transactionRestriction"
              rules={[
                {
                  required: true,
                  message: "Please select a transaction restriction",
                },
              ]}
            >
              <Select
                placeholder="Select a transaction restriction"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={transactionRestriction}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Customer Segment
                  <Tooltip title="Select the customer segment">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="customerSegment"
              rules={[
                {
                  required: true,
                  message: "Please select the customer segment",
                },
              ]}
            >
              <Select
                placeholder="Select the customer segment"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={customerSegmentOptions}
                mode="multiple"
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CustomerEligibilityForm;
